import type { Environment } from '@/core/lib/env/env.context';
import { ACTUAL_ENV, valuesFromProcess } from '@/core/lib/env/env.context';
import { ApiVersions } from '@/core/lib/fetch';
import api from '@/core/lib/fetch/api';
import type { DonationsPublicDonationCountResult, DonationsPublicDonationListResult, DonationsPublicDonationQuery } from '@/core/types/donation';
import { donationsPublicDonationCountResultSchema, donationsPublicDonationListResultSchema, donationsPublicDonationQuerySchema } from '@/core/types/donation';

const getUrl = () => valuesFromProcess[ACTUAL_ENV as Environment]?.DONNONS_API_URL;

const query = {
  get: async (data: DonationsPublicDonationQuery) => {
    const cast = donationsPublicDonationQuerySchema.cast(data, { stripUnknown: true, assert: false });

    const params = new URLSearchParams();

    Object.entries(cast).map(([key, val]) => params.set(key, val.toString()));

    const cat = params.get('cat');
    if (cat) {
      params.delete('cat');
      params.set('cat[]', cat);
    }

    const oldtags = params.get('tags');
    if (oldtags) {
      params.delete('tags');
    }
    const tags = data.tags?.filter(Boolean).map(tag => `&tags[]=${tag}`);

    return api.get<DonationsPublicDonationListResult>({
      url: `${getUrl()}${ApiVersions.V1}/donations${Array.from(params.entries()).length > 0 ? `?${params.toString()}` : ''}&nothing=nothing${tags?.length ? tags.join('') : ''}`,
      schema: donationsPublicDonationListResultSchema,
    });
  },
  count: async (data: DonationsPublicDonationQuery) => {
    const cast = donationsPublicDonationQuerySchema.cast(data, { stripUnknown: true, assert: false });

    const params = new URLSearchParams();

    Object.entries(cast).map(([key, val]) => params.set(key, val.toString()));

    const cat = params.get('cat');
    if (cat) {
      params.delete('cat');
      params.set('cat[]', cat);
    }

    const oldtags = params.get('tags');
    if (oldtags) {
      params.delete('tags');
    }
    const tags = data.tags?.filter(Boolean).map(tag => `&tags[]=${tag}`);

    return api.get<DonationsPublicDonationCountResult>({
      url: `${getUrl()}${ApiVersions.V1}/donations/count${Array.from(params.entries()).length > 0 ? `?${params.toString()}` : ''}&nothing=nothing${tags?.length ? tags.join('') : ''}`,
      schema: donationsPublicDonationCountResultSchema,
    });
  },
};

export default { query };
